import { Controller } from 'stimulus';

// Builder controller, attached to each field row inside a section. Its only
// job is to broadcast a custom event when the field's label, type, or options
// change so that sibling section-condition controllers can refresh their
// parent-field dropdowns.
export default class extends Controller {
  changed() {
    document.dispatchEvent(new CustomEvent('public-form-field-changed'));
  }
}
